import { render, staticRenderFns } from "./ProductEnlistmentCard.vue?vue&type=template&id=8244862a&"
import script from "./ProductEnlistmentCard.vue?vue&type=script&lang=js&"
export * from "./ProductEnlistmentCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductEnlistmentCard.vue?vue&type=style&index=0&id=8244862a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports